import React, { useEffect, useState } from 'react'
import { Development, RealEstateDataPageComponentData } from 'types'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import { Container, Row } from 'react-bootstrap'
import { excludeIncludeDevelopments, getReverseOrder } from '@helpers/helper.developments'

interface ButtonFilter {
  name: string
  value: number
}

const DICCIONARIO: any = {
  'VER TODOS': 1,
  'PRE-VENTA': 2,
  'EN POZO': 3,
  'EN CONSTRUCCIÓN': 4,
  TERMINADO: 5,
}

const Developments_2 = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    paragraph,
    button,
    darkMode,
    excludeTag,
    includeTag,
    is_wide,
    global_data,
    spanText,
    columns,
    is_short, //Habilitar botones filtros
  } = props

  const devCard = spanText
    ? spanText
    : global_data.content?.cardsDevelopments?.type_id
    ? global_data.content?.cardsDevelopments?.type_id
    : '4'

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(
    global_data.pageConfig.keys.tokko,
  )

  const [developments, setDevelopments] = useState<any>(allDevelopmentsData)
  const quantityToShow = 12
  const [showPartial, setShowPartial] = useState<any>(quantityToShow)

  useEffect(() => {
    if (allDevelopmentsData) {
      const devs = excludeIncludeDevelopments(allDevelopmentsData, includeTag!, excludeTag!)
      setDevelopments(devs)
    }
  }, [allDevelopmentsData])

  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  const [filter, setFilter] = useState('VER TODOS')
  const [buttons, setButtos] = useState<ButtonFilter[]>([])
  const getStatusByDevelopments = () => {
    let status = [
      {
        name: 'VER TODOS',
        value: 0,
      },
    ]
    if (allDevelopmentsData && !isLoading) {
      for (const iterator of allDevelopmentsData) {
        if (
          !status.find(
            (s) =>
              s?.name?.toLowerCase() ===
              convertStatusIdToString(iterator?.construction_status.toString()).toLowerCase(),
          )
        ) {
          status.push({
            name: convertStatusIdToString(iterator.construction_status),
            value: status.length + 1,
          })
        }
      }
    }
    return status
  }

  const convertStatusIdToString = (statusId: number | string) => {
    switch (statusId.toString()) {
      case '1':
        return 'DESCONOCIDO'
      case '2':
        return 'REUNIENDO INVERSORES'
      case '3':
        return 'EN POZO'
      case '4':
        return 'EN CONSTRUCCIÓN'
      case '5':
        return 'DETENIDO'
      case '6':
        return 'TERMINADO'
      default:
        return statusId.toString().toUpperCase()
    }
  }

  // useEffect(() => {
  //   if (allDevelopmentsData) {
  //     const devs = excludeIncludeDevelopments(allDevelopmentsData, [], excludeTag!)
  //     setDevelopments(devs)
  //   }
  // }, [allDevelopmentsData])

  useEffect(() => {
    if (developments) {
      setButtos(getStatusByDevelopments())
    }
  }, [developments])

  function filterDevs(developments: Development[]) {
    const development_array = developments
    if (filter.toLowerCase() === 'ver todos') {
      return development_array
    }
    return development_array.filter(
      (d: Development) =>
        d.construction_status.toString().toLowerCase() === filter.toString().toLowerCase() ||
        convertStatusIdToString(d.construction_status.toString()).toLowerCase() ===
          filter.toString().toLowerCase(),
    )
  }

  const WrapperContent = () => {
    if (is_wide) {
      return (
        <>
          <Row>
            {filterDevs(
              sliceDevs(getReverseOrder(developments!)?.sort((a: any, b: any) => b.id - a.id)),
            )?.map((development, i) => (
              <div className={columns ? `col-lg-${columns}` : 'col-lg-11'}>
                <Card
                  i={i}
                  key={i}
                  isItem={true}
                  development={development}
                  align={i % 2 === 0 ? 'left' : 'right'}
                  global_data={global_data}
                />
              </div>
            ))}
          </Row>
        </>
      )
    }
    return (
      <>
        <Row>
          {filterDevs(
            sliceDevs(getReverseOrder(developments!)?.sort((a: any, b: any) => b.id - a.id)),
          )?.map((development, i) => (
            <div className={columns ? `col-lg-${columns}` : 'col-lg-11'}>
              <Card
                i={i}
                key={i}
                isItem={true}
                development={development}
                align={i % 2 === 0 ? 'left' : 'right'}
                global_data={global_data}
              />
            </div>
          ))}
        </Row>
      </>
    )
  }

  const sliceDevs = (featuredSortDevs: any[]) => {
    if (showPartial >= featuredSortDevs?.length) {
      return featuredSortDevs
    }
    return featuredSortDevs?.slice(0, showPartial)
  }

  const disableBtn = () => showPartial >= getReverseOrder(developments!)?.length

  return (
    <section className={'development-about b p-y-config pb-0 ' + (darkMode ? 'dark' : '')}>
      {(title || paragraph) && (
        <div className="container-fluid flex-column d-flex justify-content-center header-container">
          {title && (
            <h2
              className={
                'text-center text-uppercase' + (paragraph ? ' mb-4' : ' space-bottom-text mb-5')
              }
            >
              {title}
            </h2>
          )}
          {paragraph && <p className="text-center mb-lg-4 mb-5 space-bottom-text">{paragraph}</p>}
          {is_short && (
            <div className={'d-flex flex-wrap mb-5 pb-lg-5 justify-content-center '}>
              {isLoading ? (
                <>
                  {[1, 2, 3, 4].map((buttonA) => (
                    <button
                      key={buttonA}
                      className={'button-filter btn mb-2 mb-lg-0 skeleton '}
                    >
                      XXXXXXXX
                    </button>
                  ))}
                </>
              ) : (
                buttons
                  .sort((a, b) => DICCIONARIO[a.name] - DICCIONARIO[b.name])
                  .map(
                    (buttonA, index) => (
                      <button
                        key={index}
                        className={
                          'button-filter mx-3 btn text-uppercase mb-2 mb-lg-0 ' +
                          (filter === buttonA.name ? ' btn-primary active ' : 'btn-primary border')
                        }
                        onClick={() => setFilter(buttonA.name)}
                      >
                        {buttonA.name}
                      </button>
                    ),
                    // )
                  )
              )}
            </div>
          )}
        </div>
      )}
      <div className={(isLoading ? '' : 'd-flex w-100') + ' container-fluid'}>
        <div className="row w-100 justify-content-center">
          <div className={is_wide ? 'col-lg-12' : 'col-lg-11'}>
            {isLoading
              ? [1].map((i, index) => (
                  <Card
                    i={i}
                    key={index}
                    isItem={true}
                    skeleton={true}
                    global_data={global_data}
                  />
                ))
              : WrapperContent()}
          </div>
        </div>
      </div>
      <div
        className={'footer-container d-flex justify-content-center ' + (isLoading ? 'd-none' : '')}
      >
        <button
          disabled={disableBtn()}
          onClick={() => setShowPartial(showPartial + quantityToShow)}
          className={
            'btn mt-5 ' +
            (darkMode ? 'btn-white white border ' : 'btn-primary ') +
            (disableBtn() ? 'btn-disabled' : '')
          }
        >
          {button?.value || 'Más emprendimientos'}
        </button>
      </div>
    </section>
  )
}

export default Developments_2
